import { Environment } from '@/domainLogic/index.ts';

enum NEXTJS_ENVIRONMENT {
  LOCAL = 'LOCAL',
  QA = 'QA',
  QATEST = 'QA-TEST',
  PREVIEW = 'PREVIEW',
  PRODUCTION = 'PRODUCTION',
}

const getRuntimeEnvironment = (): Environment => (process.env.ENVIRONMENT as Environment) || Environment.LOCAL;

export enum ENVIRONMENT_NAME {
  APP = 'app',
  CONFIG = 'config',
  SAAB = 'SAAB',
}

export type Environments = {
  [ENVIRONMENT_NAME.APP]: Environment;
  [ENVIRONMENT_NAME.CONFIG]: Environment;
  [ENVIRONMENT_NAME.SAAB]: Environment;
};

export const getEnvironments = (): Environments => {
  const environment = getRuntimeEnvironment();
  if (environment === Environment.LOCAL) {
    // Override for Local Env
    return {
      app: Environment.LOCAL,
      config: Environment.PROD, // N.B. Should match the hostname
      SAAB: Environment.QA,
    };
  }

  const env =
    (environment as string) === NEXTJS_ENVIRONMENT.QA || (environment as string) === NEXTJS_ENVIRONMENT.QATEST
      ? Environment.QA
      : Environment.PROD;
  return {
    app: env,
    config: env,
    SAAB: env,
  };
};

export const getEnvironment = (environmentName: ENVIRONMENT_NAME, environments: Environments): Environment =>
  environments ? environments[environmentName] : Environment.PROD;
